import React, { useEffect } from 'react';
import { useState, Downgraded, createState } from '@hookstate/core';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import {
    Box,
    Grid,
    Typography,
    Divider,
    RadioGroup,
    Radio,
    Select,
    MenuItem,
    InputLabel,
    TextField,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Button,
} from '@mui/material';
import { updateModuleState } from '../../stores/eventStore';
import { makeStyles } from '@mui/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import Stack from '@mui/material/Stack';
import validator from 'validator';
// import InputMask from 'react-input-mask';
import { useEventState } from '../../stores/eventStore';
import { useAgentState } from '../../hookState/AgentState';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../constants/Constant';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import AppConstants from '../../constants/appConstants';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import SedanBlue from '../../assets/images/sedan_blue.svg';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import Title from '../../sharedcomponents/title/title';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import AddCreditCard from '../AllStarTickets/ticket/addCreditCard';
import AppBarHeader from '../../sharedcomponents/appbarHeader/appbarHeader';
//import { setUserAgent } from 'react-device-detect';

const passengerCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});
const transportState = createState({
    priTransportID: 0,
    useTransport: 1,
    addedFor: '',
    totalPassengers: 0,
    pickupDate: null,
    pickupTime: null,
    pickupAddress: '',
    dropOffAddress: '',
    priContactName: '',
    priContactEmail: '',
    priContactNo: '1',
    backupContactName: '',
    backupContactEmail: '',
    backupContactNo: '',
    createdBy: null,
    isDisable: false,
    specialRequest: '',
    privateVehicle: '',
    hotel: null,
    hotelName:''
});
const CreatePrivateVehicle = (props) => {
    const classes = useStyles();
    const loading = useState(false);
    const eventState = useEventState();
    const state = useState(transportState);
    let params = useParams();
    const history = useHistory();
    const agentState = useAgentState();
    const agentInfo = Helper.getSessionStorage('agentUser');
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const [participant, setParticipant] = React.useState(null);
    // const [autoApprove, setAutoApprove] = React.useState(0);
    const [modPermission, setModPermission] = React.useState(null);
    const [participantList, setParticipantList] = React.useState(null);
    const [prevVipInfo, setPrevVipInfo] = React.useState()
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const regex = new RegExp('[^\\s]+')
    // errors
    const [useTransportErr, setUseTransportErr] = React.useState('');
    const [usevehicletypeErr, setUsevehicletypeErr] = React.useState('');
    const [priContactNameErr, setPriContactNameErr] = React.useState('');
    const [priContactEmailErr, setPriContactEmailErr] = React.useState('');
    const [priContactNoErr, setPriContactNoErr] = React.useState('');
    const [showLoading, setShowLoading] = React.useState(false);
    const [showCreditCard, setShowCreditCard] = React.useState(false);
    const [prevCreditCards, setPrevCreditCards] = React.useState([]);
    const [showCardValidationMessage, setShowCardValidationMessage] = React.useState(false);
    const [selectedCard, setSelectedCard] = React.useState(null);
    const [transportOptions, setTransportOptions] = React.useState([]);
    const logoURL = process.env.REACT_APP_CREDIT_LOGOS;
    const [hotelLErr, setHotelLErr] = React.useState('');
    const [locationErr, setLocationErr] = React.useState('');

    // const [pickupConfigDate, setPickupConfigDate] = React.useState('');

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState.get() && eventState.eventDetail.get() != null) {

            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(
                            permissions,
                            'ALLSTARHOTEL'
                        )
                    );
                }
            }
            // if (!Helper.isAdminUser(userInfo))
            // {
            //     const permissions = eventState.permissions
            //         .attach(Downgraded)
            //         .get();
            //     if (permissions && permissions.length > 0)
            //     {
            //         setModPermission(
            //             Helper.getModuleAccessPermission(
            //                 permissions,
            //                 'SATNIGHTTRANSPORT'
            //             )
            //         );
            //     }
            // } else if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))
            // {
            //     setModPermission(FULL_PERMISSION);
            // }
        }
    }, [eventState]);
    useEffect(() => {
        // const eventInfo = Helper.getStorage('eventInfo');
        // ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false))
        //     .then((res) =>
        //     {
        //         if (res.data)
        //         {
        //             res.data.map((auto) =>
        //             {
        //                 if (auto.moduleName === "SatNightTransport")
        //                 {
        //                     setAutoApprove(auto.autoApprove)
        //                 }
        //             })
        //         }
        //     })
        // getEventDefaults()
        getmoduleconfig();
    }, [])


    const getmoduleconfig = () => {
        const ModuleID = 23;
        const type = "VehicleType";

        ApiHelper.get(APIURLConstants.GET_MODULE_CONFIG(ModuleID, type))
            .then((res) => {
                console.log(res.data);
                const vehicleTypeConfig = res.data.find((element) => element.type === type);

                if (vehicleTypeConfig) {
                    const optionsArray = JSON.parse(vehicleTypeConfig.value);
                    console.log(optionsArray);
                    setTransportOptions(optionsArray);
                    console.log(optionsArray.key);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    // const getEventDefaults = () => {
    //     const gEventInfo = Helper.getStorage('eventInfo');

    //     return ApiHelper.get(APIURLConstants.GET_EVENT_CONFIG(gEventInfo.eventID)).then(res => {
    //         // console.log("res", res);
    //         if (res.data && res.data.length > 0) {
    //             res.data.map((item) => {
    //                 if (item.moduleID === 12 && item.key === "PickupDate") {
    //                     setPickupConfigDate(item.description)
    //                     state.pickupDate.set(item.description);
    //                 }
    //             })
    //         }
    //     })
    // }

    useEffect(() => {
        if (modPermission && modPermission == FULL_PERMISSION) {
            if (params.priTransportID && history.location && history.location.state && history.location.state.privateVehicleState) {
                state.priTransportID.set(params.priTransportID);
                const transportState = history.location.state.privateVehicleState;
                // console.log("transportState", transportState);
                state.set({
                    priTransportID: transportState.priTransportID,
                    useTransport: transportState.isSelected ? 1 : 0,
                    addedFor: transportState.addedFor,
                    priContactName: transportState.contactName,
                    priContactEmail: transportState.contactEmail,
                    priContactNo: transportState.contactPhone,
                    createdBy: null,
                    specialRequest: transportState.specialRequest,
                    privateVehicle: transportState.vehicleType && parseInt(transportState.vehicleType) > 0 ? parseInt(transportState.vehicleType) : '',
                    hotel: transportState.isHotelCheck != null ? (transportState.isHotelCheck === true ? 'Yes' : 'No') : null,
                    hotelName: transportState.location !== '' ? transportState.location : '' 
                });
                if (
                    transportState.creditCardID &&
                    transportState.summary &&
                    transportState.brand &&
                    transportState.cardName
                ) {
                    setSelectedCard({
                        creditCardID: transportState.creditCardID,
                        summary: transportState.summary,
                        token: '',
                        reference: '',
                        brand: transportState.brand,
                        cardName: transportState.cardName,
                        email: transportState.email,
                    });
                }
                setPrevVipInfo({
                    priTransportID: transportState.priTransportID,
                    useTransport: parseInt(transportState.useTransport),
                    addedFor: transportState.addedFor,
                    priContactName: transportState.priContactName,
                    priContactEmail: transportState.priContactEmail,
                    priContactNo: transportState.priContactNo,
                    specialRequest: transportState.specialRequest,
                    createdBy: null,
                    privateVehicle: transportState.vehicleType && parseInt(transportState.vehicleType) > 0 ? parseInt(transportState.vehicleType) : '',
                    hotel: transportState.isHotelCheck != null ? (transportState.isHotelCheck === true ? 'Yes' : 'No') : null,
                    location: transportState.location !== '' ? transportState.location : '' 
                })
            } else {
                state.priTransportID.set(0);
                resetState()
            }

            const gEventInfo = Helper.getStorage('eventInfo');
            const gUserInfo = Helper.getStorage('userInfo');

            if (
                Helper.isAdminUser(gUserInfo) ||
                (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
            ) {
                const transportStates = history.location.state.privateVehicleState;

                ApiHelper.get(
                    APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                        gEventInfo.eventID
                    )
                ).then((res) => {
                    if (res.data.rows) {
                        const participants = res.data.rows.filter(
                            (participant) =>
                                AppConstants.EVENT_ROLES_VALUES.indexOf(
                                    participant.roleName
                                ) == -1
                        );
                        if (params.priTransportID && history.location.state.privateVehicleState) {
                            const editParticipant = res.data.rows.filter(
                                (participant) => participant.userID === transportStates.addedFor)
                            setParticipant(editParticipant[0])
                            setParticipantList(participants);
                        } else {
                            setParticipantList(history.location.state.participantList);
                        }
                    }
                });
            }
        }
    }, [modPermission]);

    useEffect(() => {
        if (params && params.priTransportID) {
            state.priTransportID.set(params.transitID);
        }
        else {
            state.priTransportID.set(0);
        }
    }, [params])

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!isValidForm()) {
            return false;
        }
        else {
            // console.log(state.get());
            
            // return false
            if (participant === null) {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'please Select participant First',
                });
                return;
            }

            if (parseInt(state.useTransport.value)) {
                if (
                    selectedCard == null &&
                    selectedCard === null
                ) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Please enter credit card information first',
                    });
                    return;
                }
                if (!(params.priTransportID && history.location.state.privateVehicleState)) {
                    if (state.privateVehicle.get() === '' || state.privateVehicle.get() === '0') {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'please Select Vehicle Type First',
                        });
                        return;
                    }
                }
            }
            const eventInfo = Helper.getStorage('eventInfo');
            const userInfo = Helper.getStorage('userInfo');
            const agentInfo = Helper.getSessionStorage('agentUser');
            let reqObj
            if (parseInt(state.useTransport.value)) {
                reqObj = {
                    priTransportID: state.priTransportID.value,
                    eventID: eventInfo.eventID,
                    contactName: state.priContactName.value,
                    contactEmail: state.priContactEmail.value,
                    contactPhone: state.priContactNo.value,
                    specialRequest: state.specialRequest.value,
                    createdBy: userInfo.userID,
                    addedFor: participant ? participant.userID : userInfo.userID,
                    isSelected: true,
                    requestStatus: "pending",
                    submittedBy: userInfo.userID.toString(),
                    participant: String(participant ? participant.userID : userInfo.userID),
                    // connectionID: agentState.visible.value
                    //     ? agentInfo.userID
                    //     : state.addedFor.get()
                    //         ? state.addedFor.get()
                    //         : userInfo.userID,
                    connectionID:(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo)) ? participant ? participant.userID :  userInfo.userID : userInfo.userID,
                    vehicleType: state.privateVehicle.value ? state.privateVehicle.value.toString() : '',
                    isHotelCheck: state.hotel.get() === 'Yes' ? true : false,
                    location: state.hotel.get() === 'No' ? state.hotelName.get() : ''
                }
                if (selectedCard) {
                    reqObj['creditCardID'] = selectedCard.creditCardID
                        ? selectedCard.creditCardID
                        : 0;
                    reqObj['summary'] = selectedCard.summary;
                    reqObj['token'] = selectedCard.token;
                    reqObj['reference'] = selectedCard.reference;
                    reqObj['brand'] = selectedCard.brand;
                    reqObj['store'] = selectedCard.store;
                    reqObj['cardName'] = selectedCard.cardName;
                    reqObj['email'] = selectedCard.email;
                }
            } else {
                reqObj = {
                    priTransportID: state.priTransportID.value,
                    eventID: eventInfo.eventID,
                    contactName: "",
                    contactEmail: "",
                    contactPhone: "",
                    specialRequest: "",
                    createdBy: userInfo.userID,
                    addedFor: participant ? participant.userID : userInfo.userID,
                    isSelected: false,
                    requestStatus: "pending",
                    submittedBy: String(userInfo.userID),
                    participant: String(participant ? participant.userID : userInfo.userID),
                    vehicleType: '',
                    isHotelCheck: null,
                    location: '',
                }
                setSelectedCard([])
            }
            // console.log("reqObj",reqObj);
            // return false;
            setShowLoading(true);
            ApiHelper.post(APIURLConstants.ADD_UPDATE_PRIVATE_TRANSPORT, reqObj)
                .then(async (res) => {
                    if (res.status === 200) {
                        if (state.priTransportID.value > 0) {
                            setShowLoading(false);
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Request updated successfully',
                            });
                        }
                        else {
                            setShowLoading(false);
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Request created successfully',
                            });
                        }
                        setTimeout(() => {
                            resetState();
                            state.isDisable.set(false);
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
                            ) {
                                props.history.push(
                                    generatePath(
                                        RouteConstants.PRIVATE_VEHICLE_ADMIN_LIST,
                                        { eventID: eventInfo.eventID }
                                    )
                                );
                            } else {
                                props.history.push(
                                    generatePath(RouteConstants.PRIVATE_VEHICLE_ADMIN_LIST, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                                updateModuleState()
                            }
                        }, 1000);
                        setShowLoading(false);
                    }
                })
                .catch((err) => {
                    setShowLoading(false);
                    console.log(err);
                });
        }
    }

    const isValidForm = () => {
        let isValid = true;

        if (state.useTransport.value == null) {
            setUseTransportErr('Please select transportation option');
            isValid = false;
        }
        else {
            // console.log("state.hotel.get()",state.hotel.get(),state.hotel.value);
            
            setUseTransportErr('');
            if (parseInt(state.useTransport.value)) {
                if (!(params.priTransportID && history.location.state.privateVehicleState)) {
                    if (state.privateVehicle.get() == '' || state.privateVehicle.get() == '0') {
                        setUsevehicletypeErr('please Select Vehicle Type First')
                        isValid = false;
                    }
                }
                if (state.priContactName.value.trim().length == 0) {
                    setPriContactNameErr('Please enter primary contact name');
                    isValid = false;
                } else if (!Helper.validName(state.priContactName.get().trim())) {
                    setPriContactNameErr('Please enter valid primary contact name');
                    isValid = false;
                }
                if (state.priContactEmail.value.trim().length == 0) {
                    setPriContactEmailErr('Please enter primary contact email');
                    isValid = false;
                } else if (!Helper.validEmail(state.priContactEmail.get().trim())) {
                    setPriContactEmailErr('Please enter valid primary contact email');
                    isValid = false;
                }
                if (state.priContactNo.value.trim().length == 0 || state.priContactNo.value.trim().length == '1') {
                    setPriContactNoErr('Please enter primary contact number');
                    isValid = false;
                }
                if (state.hotel.get() === undefined || state.hotel.get() === null || state.hotel.get() === "") {
                    setHotelLErr('Please Select NBA Hotel')
                    isValid = false;
                }
                if (state.hotel.get() === "No" && (state.hotelName.get() === null || state.hotelName.get() === '' || state.hotelName.get() === undefined)) {
                    setLocationErr('Please Enter location')
                    isValid = false;
                }
            }
            else {
                setUsevehicletypeErr('')
                setPriContactNameErr('');
                setPriContactEmailErr('');
                setPriContactNoErr('');
                setHotelLErr('');
                setLocationErr('');
            }
        }
        return isValid;
    }

    const resetState = () => {
        state.set({
            priTransportID: 0,
            useTransport: 1,
            priContactName: '',
            priContactEmail: '',
            priContactNo: '1',
            specialRequest: '',
            privateVehicle: '',
        });
        setUsevehicletypeErr('')
        setPriContactNameErr('');
        setPriContactEmailErr('');
        setPriContactNoErr('');
    }
    const handleBtnCancel = () => {
        setShowLoading(false);
        resetState();
        props.history.goBack();
        handleDisableBtn();
        // props.history.push(RouteConstants.EVENT_TRANSIT);
    };

    const changeParticipant = (participant) => {
        setParticipant(participant);
    }

    const handleDisableBtn = () => {
        if (prevVipInfo != undefined) {
            const info = prevVipInfo;
            let prevData = {
                priContactName: info.priContactName,
                priContactEmail: info.priContactEmail,
                priContactNo: info.priContactNo,
                useTransport: parseInt(info.useTransport),
                specialRequest: info.specialRequest,
                summary: info.summary ? info.summary : '',
                brand: info.brand ? info.brand : '',
                cardName: info.cardName ? info.cardName : '',
                email: info.email ? info.email : '',
                creditCardID: info.creditCardID ? info.creditCardID : 0,
                vehicleType: info.vehicleType && parseInt(info.vehicleType) > 0
                    ? parseInt(info.vehicleType) : '',
                isHotelCheck: info.isHotelCheck !== null ? info.isHotelCheck : null, 
                hotelName: info.location ? info.location : '', 
            }
            let currentData = {
                priContactName: state.priContactName.get(),
                priContactEmail: state.priContactEmail.get(),
                priContactNo: state.priContactNo.get(),
                useTransport: parseInt(state.useTransport.get()),
                specialRequest: info.specialRequest,
                summary: selectedCard ? selectedCard.summary : '',
                brand: selectedCard ? selectedCard.brand : '',
                cardName: selectedCard ? selectedCard.cardName : '',
                email: selectedCard ? selectedCard.email : '',
                creditCardID: selectedCard ? selectedCard.creditCardID : 0,
                vehicleType: state.privateVehicle.get() && parseInt(state.privateVehicle.get()) > 0 ?
                    parseInt(state.privateVehicle.get()) : '',
                isHotelCheck: state.get().hotel ? (state.get().hotel === 'Yes' ? true : false) : null,
                hotelName: state.get().hotelName ? state.get().hotelName : '',
            }
            // console.log(prevData, currentData);
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }

    }

    const validateEmail = (type) => {
        const value = type == 'pri' ? state.priContactEmail.value.trim() : state.backupContactEmail.value.trim();
        //state.email.set(value);
        if (!Helper.validEmail(value)) {
            (type == 'pri') ? setPriContactEmailErr('Please enter valid primary contact email') : null;
        } else {
            (type == 'pri') ? setPriContactEmailErr('') : setBackupContactEmailErr('');
        }
    }

    const validateName = (type) => {
        const value = type == 'pri' ? state.priContactName.value : state.backupContactName.value;
        if (!Helper.validName(value)) {
            (type == 'pri') ? setPriContactNameErr('Please enter valid name') : setBackupContactNameErr('Please enter valid name');
        } else {
            (type == 'pri') ? setPriContactNameErr('') : setBackupContactNameErr('');
            return true;
        }
    }

    const validateVehicleType = (type) => {
        if (state.privateVehicle.value === '' || state.privateVehicle.value == '0') {
            (type == 'pri') ? setUsevehicletypeErr('Please select Vehicle Type') : setUsevehicletypeErr('Please select Vehicle Type');
        } else {
            (type == 'pri') ? setUsevehicletypeErr('') : setUsevehicletypeErr('');
            return true;
        }
    }
    const addCard = () => {
        // const flag = validateFields();            
        if (state.priContactName.get() !== "" && state.priContactEmail.get() !== "" && state.priContactNo.get() !== "") {
            if (userInfo.userID) {
                const passUserID = participant ? participant.userID : userInfo.userID;
                const connectionID = agentInfo ? agentInfo.userID : passUserID;

                ApiHelper.get(
                    APIURLConstants.GET_PREV_DETAILS(connectionID, passUserID)
                )
                    .then((res) => {
                        if (res.data) {
                            setPrevCreditCards(res.data);
                            setShowCreditCard(true);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                setShowCreditCard(true);
            }
        } else {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please enter mandatory information first',
            });
            return;
        }

    };
    const storeCardInfo = (obj) => {
        // console.log("cardSummary: ", cardSummary);
        // console.log("cardToken : ", cardToken);
        setSelectedCard(obj);
        setTimeout(() => {
            handleDisableBtn();
        }, 100);
    };
    const handleHotelChange = (e) => {
        state.hotel.set(e.target.value)
        setHotelLErr('');
        handleDisableBtn()
    }
    const validateLocation = () => {
        let value = state.hotel.get().trim()
        if (!validator.isAlpha(value)) {
            setLocationErr('Enter valid location')
        }else {
            setLocationErr('')
        }
    }
    // console.log("state.privatevehicle.get()",state.privatevehicle.get(), privatvehiclekey);
    return (
        <Box sx={{ width: '100%' }}>
            <Box
                className="otherContentBox"
                sx={{
                    // p: 2,
                    '& .MuiGrid-item': { p: 2 },
                    '& .MuiFormControl-root': { width: '100%' },
                }}>
                <>
                    {loading.get() ? (
                        <Box style={loader}>
                            <CircularProgress />
                        </Box>
                    ) : modPermission &&
                        modPermission == NO_ACCESS_PERMISSION ? (
                        <UnauthorizedUI showLogout={false} />
                    ) : (
                        <Box
                            component="form"
                            sx={{ width: '100%' }}
                            onSubmit={handleSubmit}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: {
                                        xs: 'column',
                                        md: 'row',
                                    },
                                    flex: 1,
                                    alignItems: 'center',
                                    margin: '10px',
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}>
                                    <Box
                                        component="img"
                                        className={classes.mobileLogo}
                                        alt="logo."
                                        src={SedanBlue}
                                    />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            paddingLeft: 3,
                                        }}>
                                        <Title
                                            title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                                                AppConstants.EVENT_MODULES.PRIVATE_TRANSPORT)}
                                            sx={{
                                                pb: 1,
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Divider
                                    orientation="vertical"
                                    light={false}
                                    sx={{ marginLeft: 2, marginRight: 5 }}
                                    flexItem
                                />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.4,
                                    }}>
                                    <ParticipantAutoList
                                        disableParticipant={
                                            history.location.state
                                                .privateVehicleState
                                                ? true
                                                : false
                                        }
                                        participantID={
                                            state.priTransportID.value > 0
                                                ? state.addedFor.value
                                                : null
                                        }
                                        participant={participant}
                                        setParticipant={changeParticipant}
                                        participantList={participantList}
                                        modPermission={modPermission}
                                    />
                                </Box>
                            </Box>
                            <Divider
                                light={false}
                                sx={{ marginTop: 2, marginRight: 0 }}
                                flexItem
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    pt: 1,
                                    pb: 1,
                                    flex: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.25,
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        flexFlow: 'wrap',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        flexGrow={1}
                                        fontSize={15}
                                        fontWeight={700}
                                        fontFamily={'Lato'}
                                        noWrap
                                        fontStyle="normal"
                                        color="primary"
                                        component="div"
                                        sx={{
                                            ml: 1,
                                            mr: 1,
                                        }}>
                                        Will You Be Using the Private
                                        Vehicle Provided by the NBA?
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.4,
                                        position: 'relative',
                                        top: '3px',
                                    }}>
                                    <FormControl
                                        component="fieldset"
                                        error={
                                            useTransportErr.length > 0
                                                ? true
                                                : false
                                        }>
                                        <RadioGroup
                                            row
                                            aria-labelledby="sat-night-transport"
                                            name="useTransport"
                                            value={state.useTransport.get()}
                                            onChange={(event) => {
                                                state.useTransport.set(
                                                    event.target.value
                                                );
                                                handleDisableBtn();
                                            }}>
                                            <FormControlLabel
                                                value={1}
                                                control={<Radio />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value={0}
                                                control={<Radio />}
                                                label="No"
                                            />
                                        </RadioGroup>
                                        <FormHelperText>
                                            {useTransportErr}
                                        </FormHelperText>
                                    </FormControl>
                                </Box>
                            </Box>
                            <Box
                                sx={
                                    state.useTransport.get() == 1
                                        ? { display: 'block' }
                                        : { display: 'none' }
                                }
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        pt: 1,
                                        pb: 1,
                                        flex: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flex: 0.334,
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                            flexFlow: 'wrap',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={15}
                                            fontWeight={700}
                                            fontFamily={'Lato'}
                                            noWrap
                                            fontStyle="normal"
                                            color="primary"
                                            component="div"
                                            sx={{
                                                ml: 1,
                                                mr: 1,
                                            }}>
                                            Requested Vehicle Type :
                                        </Typography>
                                    </Box>
                                    {transportOptions && transportOptions.length > 0 ? <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flex: 0.645,
                                            position: 'relative',
                                            top: '3px',
                                        }}>
                                        <FormControl size='small'>
                                            <InputLabel id="demo-simple-select-label">Vehicle Type</InputLabel>
                                            <Select
                                                sx={{
                                                    width: '50%',
                                                }}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={state.privateVehicle.get()}
                                                required={true}
                                                label="Vehicle Type"
                                                onChange={(event) => {

                                                    state.privateVehicle.set(
                                                        event.target.value
                                                    );

                                                    setDisableBtn(false);
                                                }}
                                                error={
                                                    usevehicletypeErr.length > 0
                                                        ? true
                                                        : false
                                                }
                                                onBlur={() => validateVehicleType('pri')}
                                            >
                                                {transportOptions.map((option) => (
                                                    <MenuItem
                                                        key={option.key}
                                                        value={option.key}
                                                        style={{
                                                            padding:
                                                                '2.5px 4px 2.5px 8px',
                                                        }}>
                                                        <span>{option.value}</span>
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText error={usevehicletypeErr.length > 0}>{usevehicletypeErr}</FormHelperText>
                                        </FormControl>

                                    </Box> : null}
                                </Box>
                            </Box>
                            <Box
                                sx={
                                    state.useTransport.get() == 1
                                        ? { display: 'block' }
                                        : { display: 'none' }
                                }>
                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={1}
                                    sx={{
                                        padding: 0,
                                        // marginTop: 1,
                                    }}>
                                    <Grid sx={{pt:2}} lg={12} md={12} xs={12}>
                                        <AppBarHeader
                                            title="Main POC" 
                                            showTranportText={true}
                                        /> 
                                    </Grid>
                                    <Grid item lg={4} md={6} xs={12}>
                                        <TextField
                                            size="small"
                                            required
                                            id="outlined-required"
                                            label="Name"
                                            autoComplete="off"
                                            value={state.priContactName.get()}
                                            onChange={(event) => {
                                                regex.test(
                                                    event.target.value
                                                )
                                                    ? state.priContactName.set(
                                                        event.target.value
                                                    )
                                                    : state.priContactName.set(
                                                        event.target.value.trim()
                                                    );
                                                handleDisableBtn();
                                            }}
                                            inputProps={{ maxLength: 50 }}
                                            onBlur={() =>
                                                validateName('pri')
                                            }
                                            helperText={priContactNameErr}
                                            error={
                                                priContactNameErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </Grid>
                                    <Grid item lg={4} md={6} xs={12}>
                                        <TextField
                                            size="small"
                                            required
                                            id="outlined-required"
                                            label="Email"
                                            autoComplete="off"
                                            value={state.priContactEmail.get()}
                                            onChange={(event) => {
                                                state.priContactEmail.set(
                                                    event.target.value
                                                );
                                                handleDisableBtn();
                                            }}
                                            inputProps={{ maxLength: 250 }}
                                            onBlur={() =>
                                                validateEmail('pri')
                                            }
                                            helperText={priContactEmailErr}
                                            error={
                                                priContactEmailErr.length >
                                                    0
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </Grid>
                                    <Grid item lg={4} md={6} xs={12}>
                                        <PhoneNumber
                                            name={'privateContact'}
                                            placeholder="Contact No*"
                                            value={state.priContactNo.get()}
                                            onChange={(ph) => {
                                                state.priContactNo.set(ph);
                                                handleDisableBtn();
                                                setPriContactNoErr('');
                                            }}
                                            required={true}
                                            helperText={priContactNoErr}
                                            error={
                                                priContactNoErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={1}
                                    sx={{
                                        padding: 0,
                                        marginTop: 1,
                                    }}>
                                    <Grid item lg={4} md={6} xs={12}>
                                        <TextField
                                            size="small"
                                            id="outlined-required"
                                            label="Special Request"
                                            value={
                                                state.specialRequest.get()
                                                    ? state.specialRequest.get()
                                                    : ''
                                            }
                                            onChange={(event) => {
                                                state.specialRequest.set(
                                                    event.target.value
                                                );
                                                handleDisableBtn();
                                            }}
                                            inputProps={{
                                                maxLength: 260,
                                            }}
                                            multiline={true}
                                            minRows={3}
                                            maxRows={10}
                                        />
                                    </Grid> 
                                    <Grid item lg={3} md={6} xs={12}>
                                        <Button
                                            variant="text"
                                            onClick={addCard}>
                                            {params.priTransportID > 0
                                                ? 'Edit Card Details'
                                                : 'Add Card Details'}
                                        </Button>
                                        {selectedCard ? (
                                            <Box
                                                component="div"
                                                sx={{
                                                    pl: 1,
                                                    pr: 1,
                                                    pt: 0.5,
                                                    pb: 0.5,
                                                }}>
                                                {/* <img src={`${logoURL}${'visa'}.svg`} width='24' height={16} style={{border: '1px solid #ccc', borderRadius: 4, marginRight: '8px'}} />{`****-${'4000'} - ${'Amit'}`} */}
                                                <img
                                                    src={`${logoURL}${selectedCard.brand}.svg`}
                                                    width="24"
                                                    height={16}
                                                    style={{
                                                        border: '1px solid #ccc',
                                                        borderRadius: 4,
                                                        marginRight: '8px',
                                                    }}
                                                />
                                                {`****-${selectedCard.summary} - ${selectedCard.cardName}`}
                                            </Box>
                                        ) : null}
                                    </Grid>
                                    <Grid item lg={5} md={6} xs={12}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                            }}>
                                            <Typography variant="subtitle2" sx={{width:'100%'}} >
                                                Is the participant staying at the NBA
                                                hotel?
                                            </Typography>
                                            <FormControl
                                                sx={{width:'80% !important' }}
                                                error={
                                                    hotelLErr.length > 0 ? true : false
                                                }
                                                variant="standard">
                                                <RadioGroup
                                                 
                                                    row
                                                    sx={{ ml: 1}}
                                                    onChange={(e) =>
                                                        handleHotelChange(e)
                                                    } 
                                                    value={
                                                        state.hotel.get() ? 'Yes' : 'No'
                                                    }>
                                                    <FormControlLabel
                                                        value="Yes"
                                                        control={
                                                            <Radio
                                                                checked={
                                                                    state.hotel.get() ===
                                                                    'Yes'
                                                                }
                                                            />
                                                        }
                                                        label="Yes"
                                                    />
                                                    <FormControlLabel
                                                        value="No"
                                                        control={
                                                            <Radio
                                                                checked={
                                                                    state.hotel.get() ===
                                                                    'No'
                                                                }
                                                            />
                                                        }
                                                        label="No"
                                                    />
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {hotelLErr}
                                                </FormHelperText>
                                            </FormControl> 
                                        </Box>
                                        <Typography variant="caption">
                                            <b>Note:</b> If no, please provide the
                                            location where the participant will be
                                            staying.
                                        </Typography>
                                        {state.hotel.get() === 'No' ? (
                                            <TextField
                                                fullWidth
                                                required
                                                size="small"
                                                id="outlined-basic"
                                                variant="outlined"
                                                label="Participant Location"
                                                inputProps={{ maxLength: 200 }}
                                                // disabled={!checkEditPermission}
                                                value={state.hotelName.get()}
                                                onBlur={() =>
                                                    params.userID > 0
                                                        ? null
                                                        : validateLocation()
                                                }
                                                error={
                                                    locationErr.length > 0
                                                        ? true
                                                        : false
                                                }
                                                helperText={
                                                    locationErr.length > 0
                                                        ? locationErr
                                                        : ''
                                                }
                                                onChange={(event) => {
                                                    state.hotelName.set(
                                                        event.target.value
                                                    );
                                                    handleDisableBtn();
                                                    validateLocation();
                                                }}
                                                sx={{mt:1}}
                                            />
                                        ) : null}
                                    </Grid>
                                </Grid>
                            </Box>
                            {showCreditCard ? (
                                <AddCreditCard
                                    showCreditCard={showCreditCard}
                                    hideCreditCard={setShowCreditCard}
                                    storeCardInfo={storeCardInfo}
                                    userID={
                                        participant
                                            ? participant.userID
                                            : userInfo.userID
                                    }
                                    eventID={eventInfo.eventID}
                                    connection={
                                        agentInfo
                                            ? agentInfo.userID
                                            : participant
                                                ? participant.userID
                                                : userInfo.userID
                                    }
                                    prevCreditCards={prevCreditCards}
                                    setSnackBarProps={setSnackBarProps}
                                    setShowCardValidationMessage={
                                        setShowCardValidationMessage
                                    }
                                // existingCard={existingCard}
                                />
                            ) : null}
                            <ButtonContainer
                                handleClick={handleSubmit}
                                handleCancel={handleBtnCancel}
                                loading={showLoading}
                                showLoading={showLoading}
                                buttonText={
                                    state.priTransportID.get() > 0
                                        ? history.location.state &&
                                            history.location.state
                                                .privateVehicleState &&
                                            history.location.state.privateVehicleState.requestStatus.toLowerCase() ===
                                            'pending'
                                            ? 'Update & Submit'
                                            : 'Update'
                                        : 'Submit'
                                }
                                // disableButton={state.isDisable.get()}
                                disableUpdateButton={
                                    state.priTransportID.get() > 0
                                        ? disableBtn
                                        : false
                                }
                            />
                        </Box>
                    )}
                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: false,
                                })
                            }></CustomizedSnackbars>
                    )}
                </>
            </Box>
        </Box>
    );
}

export default {
    routeProps: {
        path: [RouteConstants.PRIVATE_VEHICLE_CREATE, RouteConstants.PRIVATE_VEHICLE_EDIT],
        component: CreatePrivateVehicle,
    },
    name: 'CreatePrivateVehicle',
};